const Message = ({ notification }) => {
  return (
    <div style={styles.notificationContainer}>
      <div style={styles.notificationHeader}>
        {notification.image && (
          <div style={styles.imageContainer}>
            <img src={notification.image} alt="" width={50} height={50} style={styles.image} />
          </div>
        )}
        <span style={styles.title}>{notification.title}</span>
      </div>
      <div style={styles.notificationBody}>{notification.body}</div>
    </div>
  );
};

const styles = {
  notificationContainer: {
    backgroundColor: "#fff",
    color: "#ff4d4d",
    padding: "10px",
    borderRadius: "8px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    maxWidth: "350px",
    fontFamily: "Arial, sans-serif",
  },
  notificationHeader: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "16px",
    fontWeight: "bold",
  },
  imageContainer: {
    flexShrink: 0,
  },
  image: {
    borderRadius: "50%",
    objectFit: "cover",
  },
  title: {
    flex: 1,
  },
  notificationBody: {
    marginTop: "5px",
    fontSize: "14px",
    lineHeight: "1.5",
    color: "black"
  },
};

export default Message;
